export const normalizeOutput = <T>(expression: ((input: any) => T) | T, input: any): T => {
  return expression instanceof Function ? expression(input) : expression;
};
